import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navbar from './components/aravi/Navbar';
import Footer from './components/aravi/Footer';
import ScrollToTop from './components/aravi/ScrollToTop';
import Home from './pages/Home';
import Residences from './pages/Residences';
import ResidenceDetail from './pages/ResidenceDetail';
import Philosophy from './pages/Philosophy';
import Landscapes from './pages/Landscapes';
import Sustainability from './pages/Sustainability';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[#F5F1E8] text-[#18342A] font-sans-brand">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="bottom-right" richColors />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/residences" element={<Shell><Residences /></Shell>} />
          <Route path="/residences/:slug" element={<Shell><ResidenceDetail /></Shell>} />
          <Route path="/philosophy" element={<Shell><Philosophy /></Shell>} />
          <Route path="/landscapes" element={<Shell><Landscapes /></Shell>} />
          <Route path="/sustainability" element={<Shell><Sustainability /></Shell>} />
          <Route path="/contact" element={<Shell><Contact /></Shell>} />
          <Route path="*" element={<Shell><NotFound /></Shell>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
